<dialog class="ox-modal" aria-modal="true" open>
  <button type="button" class="ox-modal__close" aria-label="Close the modal" (click)="reject()">
    <span class="ox-icon ox-icon--close ox-icon--small"></span>
  </button>
  <div class="ox-modal__body">
    <h3 class="ox-modal__title">{{ dialogText }}</h3>
  </div>
  <div class="ox-modal__footer">
    <div class="ox-button-group ox-button-group--right">
      <button type="button" class="ox-button ox-button--primary" autofocus="true" (click)="confirm()">
        @switch (this.injectedData.type) {
          @case (confType.END_STOP_TRACKING_UNFINISHED) {
            <span
            >{{ 'MESSAGE.DEPART_ANYWAY' | translate | titlecase }}</span>
          }
          @case (confType.PROTOCOL_SAVE_DRAFT) {
            <span>{{ 'COMMON.OK' | translate | titlecase }}</span>
          }
          @default {
            <span>{{ 'COMMON.YES' | translate | titlecase }}</span>
          }
        }
      </button>
      <button type="button" class="ox-button ox-button--secondary" (click)="reject()">
        @switch (this.injectedData.type) {
          @case (confType.END_STOP_TRACKING_UNFINISHED) {
            <span
            >{{ 'COMMON.OK' | translate | titlecase }}</span>
          }
          @case (confType.PROTOCOL_SAVE_DRAFT) {
            <span
            >{{ 'COMMON.CANCEL' | translate | titlecase }}</span>
          }
          @default {
            <span>{{ 'COMMON.NO' | translate | titlecase }}</span>
          }
        }
      </button>
    </div>
  </div>
</dialog>
